module.exports = __webpack_public_path__ + "018f35ec6e7a4bddbdae3f53e9e21403.pdf";